export const PUBLIC_LANGUAGES = [
  'en',
  'de',
  'es',
  'fr',
  'it',
  'ja',
  'nl',
  'pt',
  'zh-tw',
  'zh-cn',
  'fi',
  'da',
  'no',
  'pl',
  'sv',
  'th',
  'ko',
] as const;

export const MARKETPLACE_SUPPORTED_LANGUAGES = [
  'en',
  'de',
  'es',
  'fr',
  'it',
  'ja',
  'nl',
  'pt-br',
  'zh-tw',
  'zh-cn',
  'fi',
  'da',
  'no',
  'pl',
  'sv',
  'th',
  'ko',
] as const;

export const CUSTOMER_SUPPORT_LANGUAGES = [
  'af',
  'sq',
  'ar',
  'hy',
  'eu',
  'be',
  'bg',
  'ca',
  'zh',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'et',
  'fo',
  'fa',
  'fi',
  'fr',
  'gl',
  'ka',
  'de',
  'el',
  'gu',
  'he',
  'hi',
  'hu',
  'is',
  'id',
  'ga',
  'it',
  'ja',
  'kn',
  'kk',
  'kok',
  'ko',
  'ky',
  'lv',
  'lt',
  'mk',
  'ms',
  'mt',
  'mr',
  'mn',
  'my',
  'no',
  'nb',
  'pl',
  'pt',
  'pa',
  'ro',
  'ru',
  'sa',
  'sr',
  'sk',
  'sl',
  'es',
  'sw',
  'sv',
  'sy',
  'ta',
  'tt',
  'te',
  'th',
  'tr',
  'uk',
  'ur',
  'vi',
];

// Countries to exclude from profile options, either because duplicate or invalid
export const SOLUTIONS_EXCLUDED_COUNTRIES = ['uk', 'eu', 'ap'];

// TODO: Standardize with apps & assets marketplace
export const SOLUTIONS_FILTERS_LANGUAGES = [
  'af',
  'sq',
  'ar',
  'hy',
  'az',
  'eu',
  'be',
  'bn',
  'bg',
  'my',
  'ca',
  'zh',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'et',
  'fo',
  'fa',
  'fi',
  'fil',
  'fr',
  'gl',
  'ka',
  'de',
  'el',
  'gu',
  'ha',
  'he',
  'hi',
  'hu',
  'is',
  'id',
  'ga',
  'it',
  'ja',
  'kn',
  'kk',
  'kok',
  'ko',
  'ky',
  'lo',
  'lv',
  'lt',
  'mk',
  'ms',
  'ml',
  'mt',
  'mr',
  'mn',
  'no',
  'nb',
  'pl',
  'pt',
  'pa',
  'ro',
  'ru',
  'sa',
  'sr',
  'si',
  'sk',
  'sl',
  'es',
  'sw',
  'sv',
  'sy',
  'ta',
  'tt',
  'te',
  'th',
  'tr',
  'uk',
  'ur',
  'uz',
  'vi',
  'yi',
  'zu',
];
